// PHSIQ collections index: scroll reveals, cursor-follow card fill/parallax,
// and count-up stats. Everything degrades to a static page without JS.
(() => {
  const init = (root) => {
    if (root.dataset.pciReady) return
    root.dataset.pciReady = 'true'

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches
    const reveals = root.querySelectorAll('.pci-reveal, [data-pci-card]')

    if (!('IntersectionObserver' in window) || reduceMotion) {
      reveals.forEach((el) => el.classList.add('is-inview', 'is-settled'))
    } else {
      root.classList.add('pci--js')
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return
            const el = entry.target
            el.classList.add('is-inview')
            io.unobserve(el)
            if (el.hasAttribute('data-pci-card')) {
              const i = parseInt(getComputedStyle(el).getPropertyValue('--i'), 10) || 0
              setTimeout(() => el.classList.add('is-settled'), 1200 + i * 90)
            }
          })
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      )
      reveals.forEach((el) => io.observe(el))
    }

    // Cursor-driven fill origin, red spotlight and image parallax.
    if (canHover && !reduceMotion) {
      root.querySelectorAll('[data-pci-card]').forEach((card) => {
        let frame = 0
        const update = (event) => {
          const rect = card.getBoundingClientRect()
          const x = (event.clientX - rect.left) / rect.width
          const y = (event.clientY - rect.top) / rect.height
          cancelAnimationFrame(frame)
          frame = requestAnimationFrame(() => {
            card.style.setProperty('--mx', `${(x * 100).toFixed(1)}%`)
            card.style.setProperty('--my', `${(y * 100).toFixed(1)}%`)
            card.style.setProperty('--px', ((x - 0.5) * 2).toFixed(3))
            card.style.setProperty('--py', ((y - 0.5) * 2).toFixed(3))
          })
        }
        card.addEventListener('pointerenter', update)
        card.addEventListener('pointermove', update)
        card.addEventListener('pointerleave', () => {
          cancelAnimationFrame(frame)
          card.style.setProperty('--px', 0)
          card.style.setProperty('--py', 0)
        })
      })
    }

    // Count-up for hero stats.
    const counters = root.querySelectorAll('[data-pci-count]')
    if (counters.length && !reduceMotion && 'IntersectionObserver' in window) {
      const run = (el) => {
        const target = parseInt(el.dataset.pciCount, 10)
        if (!target) return
        const start = performance.now()
        const duration = Math.min(1600, 500 + target * 40)
        const tick = (now) => {
          const p = Math.min(1, (now - start) / duration)
          el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)))
          if (p < 1) requestAnimationFrame(tick)
        }
        el.textContent = '0'
        requestAnimationFrame(tick)
      }
      const cio = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          cio.unobserve(entry.target)
          setTimeout(() => run(entry.target), 400)
        })
      })
      counters.forEach((el) => cio.observe(el))
    }
  }

  const boot = () => document.querySelectorAll('[data-pci]').forEach(init)
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot)
  else boot()

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', boot)
})()
